// 基本常量
const CONST_DATA = {
    EDIT: '编辑',
    ADD: '新增',
    REVIEW: '审核',
    REJECT: '驳回',
    REVIEW_SUCCESS: '审核成功',
    REJECT_SUCCESS: '驳回成功',
    SAVE_SUCCESS: '保存成功',
    CANCEL_SUCCESS: '取消成功',
    HUNDRED: 100, // 一百
    BYTE_NUM: 1024, // 字节值
    HL: 'HL', // 家居物流
    TOTAL_VOLUME: 'totalVolume', // 总体积
    TEXT: 'text',
    ENABLE: '启用',
    DISABLED: '停用',
    TURN_ON: '开启',
    TURN_OFF: '关闭',
    OPEN: '开',
    CLOSE: '关',
    ERROR_TIP: '数据有误',

    // 业务控制参数
    CUSTOMER: 'CUSTOMER', // 客户
    WH: 'WH', // 仓库
    SITE: 'SITE', // 平台
    SWITCH: 'switch', // 开关
    CONTROLVALUE: 'CONTROLVALUE', // 控制点

    // 时效产品  normal
    AGINGTYPE_CUSTOMER: '3',
    AGINGTYPE_NORMAL: '2'
};

// 正则常量
const REG_CONST = {
    IS_REG_TELEPHONE: /^(\d{3,4}-)\d{6,8}$/, // 固话
    IS_REG_MOBILE: /^1\d{10}$/, // 手机正则
    REG_ONLY_FIXED_PHONE: /[^0-9\-$]/g, // 只支持固话、电话输入正则
    REG_ONLY_INT: /[^\d]/g, // 替换除数字外的字符，用于只能输入整数
    // // 正则表达式，匹配0、正数及最多6位小数
    // SIX_POINT_NUMBER: /^(0|[1-9]\d*)?(\.\d{1,6})?$/,
    REG_ONLY_NUMBER: /[^\d\.]/g // 用于支持小数点数值
};

// 对象数组类型
const OBJECT_CONST = {
    PIC_TYPES: ['jpg', 'png', 'gif', 'jpeg', 'tif', 'bmp', 'webp']
};

export default {
    CONST_DATA,
    REG_CONST,
    OBJECT_CONST
};
